import * as Yup from "yup";

export const validationSchemaRent = Yup.object({
    contrato_renta: Yup.mixed().when("isRented", {
        is: true,
        then: (schema) => schema.required("Contrato de renta obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    ine_inquilino: Yup.mixed().when("isRented", {
        is: true,
        then: (schema) => schema.required("INE obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    poliza_juridica: Yup.mixed().when(["isRented", "isAval"], {
        is: (isRented, isAval) => isRented && !isAval,
        then: (schema) => schema.required("Poliza jurídica obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    ine_aval: Yup.mixed().when(["isRented", "isAval"], {
        is: (isRented, isAval) => isRented && isAval,
        then: (schema) => schema.required("INE del Aval obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    comprobante_aval: Yup.mixed().when(["isRented", "isAval"], {
        is: (isRented, isAval) => isRented && isAval,
        then: (schema) => schema.required("Comprobante de domicilio del Aval obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userId: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === false,
        then: (schema) => schema.required("Inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userCellphone: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === true,
        then: (schema) => schema.required("Teléfono del inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userEmail: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === true,
        then: (schema) => schema.required("Email del inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    userName: Yup.string().when(["isRented", "create"], {
        is: (isRented, create) => isRented === true && create === true,
        then: (schema) => schema.required("Nombre del inquilino obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    monto: Yup.number()
    .typeError("El monto debe ser un número")
    .positive("El monto debe ser positivo")
    .when("isRented", {
        is: true,
        then: (schema) => schema.required("El monto es obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    iva: Yup.number()
    .typeError("El IVA debe ser un número")
    .min(0, "El IVA no puede ser negativo")
    .when("isRented", {
        is: true,
        then: (schema) => schema.required("El IVA es obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    subtotal: Yup.number()
    .typeError("El subtotal debe ser un número")
    .positive("El subtotal debe ser positivo")
    .when("isRented", {
        is: true,
        then: (schema) => schema.required("El subtotal es obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    date_start: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("Fecha de inicio obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    date_end: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("Fecha de fin obligatoria"),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_email: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("email obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_razonSocial: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("Razon social obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_rfc: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("RFC obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    fac_usoCFDI: Yup.string().when("isRented", {
        is: true,
        then: (schema) => schema.required("Uso del CFDI obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
    code: Yup.string().when("isRented", {
        is: false,
        then: (schema) => schema.required("Código de confirmación obligatorio"),
        otherwise: (schema) => schema.notRequired(),
    }),
});